import React from "react"
import Loading from "../../animation/Loading"
import * as Style from "./Loader.module.scss"

const Loader = props => {
  return (
    <div className={`${Style.loaderContainer} ${props.style}`}>
      <div
        className={`${Style.loaderAnimationWrapper} ${props.animationStyle}`}
      >
        <Loading />
      </div>
    </div>
  )
}

export default Loader
